import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// components
import MainHeader from "../../components/Header/MainHeader";
import SelectOption from "../../components/Select/SelectOption";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { addMaritalStatus } from "../../redux/slices/registerSlice";
import { useNavigate } from "react-router-dom";
import { googleEvent_LOJ052 } from "../../lib/google-analytics";
import { googleEvent_LOJ050 } from "../../lib/google-analytics-loan-journey-events";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function Marital() {
  const [loading, setLoading] = useState(false);

  const { maritalStatus } = useSelector((state) => state.register);
  const { repeatCustomer } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { incompleteDetailsUpdate } = new ServicesAPI();
  const { handleStep } = useResponse();

  const data = ["Single", "Married"];

  const handleIncompleteDetailsUpdateAPI = async (data) => {
    setLoading(true);

    const res = await incompleteDetailsUpdate(data, repeatCustomer);

    if (res && res.statusCode === 200) {
      dispatch(addMaritalStatus(data.value));

      if (repeatCustomer) {
        navigate("/confirm-details");
      } else {
        handleStep();
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    googleEvent_LOJ050();
  }, []);

  useEffect(() => {
    loading ? handleShowContextualLoader("Please wait...") : handlehideContextualLoader();
  }, [loading]);

  return (
    <>
      <div className="wrapper">
        <MainHeader
          title="Personal Info"
          showProgress={true}
          percent={15.38}
          backPageName={repeatCustomer ? "/confirm-details" : ""}
        />

        <div className="mb-3">
          <p className="label">Marital Status</p>
        </div>

        {data.map((item, index) => (
          <div
            key={index}
            onClick={async () => {
              handleIncompleteDetailsUpdateAPI({
                key: "marrital",
                value: item,
              });

              // Events
              googleEvent_LOJ052(item, item);
            }}
          >
            <SelectOption name={item} checked={maritalStatus} />
          </div>
        ))}
      </div>

    </>
  );
}
